export default "__VITE_ASSET__C9c_zYUw__"